import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

interface SpotifyAlbumQueryOptionsInput {
  workId: string;
  enabled?: boolean;
}

export function getSpotifyAlbumQueryOptions({ workId, enabled }: SpotifyAlbumQueryOptionsInput) {
  return deferredResourceQueryOptions(
    orpc.music.getSpotifyAlbumResource.queryOptions({
      input: { workId },
      enabled,
    }),
  );
}
